define([], () => {
    'use strict';

    /**
     * @param {Object} config component configuration
     * @param {HTMLAnchorElement} element menu toggle anchor
     */
    function initialize (config, element) {
        const menuEl = document.querySelector('[data-menu-toggle-attrs]');
        if (menuEl) {
            Object.entries(JSON.parse(menuEl.dataset.menuToggleAttrs))
                .forEach(([attr, attrVal]) => element.setAttribute(attr, attrVal));
        }
    }

    return initialize;
});
